import React from 'react';
import './index.scss';

const PrintPage: React.FC = () => {
  const printPage = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.print();
  };
  return (
    <div className="print_page">
      <button onClick={printPage}>
        <i className="fa fa-print" />
        <span>Print</span>
      </button>
    </div>
  );
};

export default PrintPage;
